<template>
  <div class="info">
     
<div class="parallax  bgimg-1">
   <router-link :to="{ name: 'Login'}" v-if="!session">
      <md-button style="z-index:1000;float:right;margin-right:20px" class="md-raised md-info" >SIGN IN</md-button>
    </router-link>
    <router-link :to="{ name: 'Dashboard'}" v-if="session">
      <md-button style="z-index:1000;float:right;margin-right:20px" class="md-raised md-info" >HOME</md-button>
    </router-link>
   <div class="info-logo"></div>
       
</div>
<!--
<vue-particles
        color="#dedede"
        :particleOpacity="0.7"
        :particlesNumber="80"
        shapeType="circle"
        :particleSize="4"
        linesColor="#dedede"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
      >
      </vue-particles> 
      -->
 <div class="info-text-overlay">
    
      <div class="info-text">
       <h2>Instant recall on everything you learn......you ready?</h2>
        
        <br/>This is how it works...
        <div>Anytime you learn anything you create a new Memry. 
          <span>A memry is a good concise summary of whatever it is you want to remember (even a good story!)</span>
        </div>
        <div>Add your new Memry and assign some tags
          <span>With good tags you'll build a great catalog of everything in your brain!</span>
        </div>
        <div>My Memry will prompt you to review the material at a carefully designed interval
          <span>This is based on an ancient and proven memory review cycle which moves the information from your short-term to long-term memory!</span>
        </div>
        <div>Check in daily to do your reviews and add more memries. Before you know it you will have a new brain!
          <span>Wherever you are load up My Memry and in a matter of minutes do your reviews</span>
        </div>
        <br/>
        <br/>
        <div>We never said it wouldn't take some work and discipline. But before you know it you'll be moving everything from your short-term memory into your long-term memory</div>
      </div>

  </div>

<div class="parallax  bgimg-2">
  <div style="color:#ddd;text-align:center;padding:80px;text-align: center;font-size:25px;">
    Review everything you have ever learnt in just 10 minutes a day!
    <div>
     <router-link :to="{ name: 'Login'}" v-if="!session">
          <md-button  class="md-raised md-info" >GET STARTED</md-button>
    </router-link>
    <router-link :to="{ name: 'Dashboard'}"  v-if="session">
          <md-button  class="md-raised md-info" >GET STARTED</md-button>
    </router-link>
  </div>
  </div>
  
</div>


<div style="position:relative;color:#ddd;line-height:28px;background-color:#282E34;text-align:left;padding:50px 80px;text-align: center;font-size:20px;">
  Build, organize and review everything you learn using a proven memory system.
     <br/>
  <img v-for="(item,index) in images" :key="index" :src="item.url" @click="imageView(index)" style="cursor:pointer;height:200px;margin-right:20px;margin-top:20px" >
  <br/><br/>
  For School, College or University students or just a student of Life!<br/>If you learn something, why forget it?!
</div>
  

<div class="parallax bgimg-2">
  <div class="caption">
  <span class="border" style="background-color:transparent;font-size:25px;color: #f7f7f7;"></span>
  </div>
</div>

<div style="position:relative;color:#ddd;line-height:28px;background-color:#282E34;text-align:left;padding:50px 80px;text-align: center;font-size:20px;">
    Create. Organize. Review. Review. <br/> REMEMBER!<br/>
 </div>
  

<div style="position:relative;">
  
  <div class="footer" >
  <div><md-icon style="color:white">email</md-icon><a style="color:white" href="mailto:info@mymemry.com">info@mymemry.com</a></div>
  <div><md-icon style="color:white">copyright</md-icon> Copyright © 2020 My Memry. All rights reserved.</div>
  </div>
</div>

<!--
<div class="parallax bgimg-1">
  <div class="caption">
  <span class="border">COOL!</span>
  </div>
</div>
-->
    <div class="" >
     
      
    </div>
  </div>
</template>
<style>

.parallax {

    /* The image used */
  background-image: url("../assets/img/starsky.jpg");
  /* Set a specific height */

  min-height: 100%;
  /* Create the parallax scrolling effect */
  position: relative;
  /*opacity: 0.65;*/
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

}
.bgimg-1 {
    height: 500px;

}

.bgimg-2 {
    height: 250px;

}


#particles-js {
      position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

a:hover {
  color:white;
}

.footer {
  height:200px;color:#ddd;background-color:#282E34;text-align:center;padding:50px 80px;text-align: center;
}

.footer div {
  margin-top:5px;
}

.button {
     text-align: center;
    padding-top: 100px;
}


@media only screen and (max-device-width: 1366px) {
  .parallax {
    background-attachment: scroll;
  }
}
</style>

<script>
import ApiService from "@/services/api.service";


export default {
  
  data() {
    return {
       session : null,
      images : [
            {
                name : "Todays list",
                url :  require("@/assets/img/memry_today.png")
            },
            {
                name : "Review & Score",
                url : require("@/assets/img/memry_score.png")
            },
            {
                name : "Create a Memry",
                url : require("@/assets/img/memry_new.png")
            },
             {
                name : "View & Search",
                url : require("@/assets/img/memry_all.png")
            },
             {
                name : "Manage Tags",
                url : require("@/assets/img/memry_tags.png")
            },
        ]
    }
  },
  created() {
     this.$imageViewer.images(this.images);
  },
  mounted() {
    this.getSession();
    if(this.$route.query.insession)
       this.session = true;
    

  },
  methods: {
    getSession() {
       /* ApiService.getSession().then((res) => {
            console.log('Session',res);
            if(res.data)
              this.session = res.data;
        }) */
    },
    imageView(index) {
            this.$imageViewer.index(index);
            this.$imageViewer.show();
        }
  }
};
</script>
